import React, { memo } from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Slider from '@material-ui/core/Slider';

import {
  useStyles,
  useStylesGrid,
  useStylesSlider,
  useStylesTypography,
} from './styles';

function FlavourPreferenceSlider({
  id,
  value,
  handleChangeValueSlider,
  left,
  right,
}) {
  const classes = useStyles();
  const classesSlider = useStylesSlider();
  const classesGrid = useStylesGrid();
  const classesTypography = useStylesTypography();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={2}>
            <Grid item xs={6} classes={classesGrid}>
              <Typography
                align="left"
                className={clsx(
                  classesTypography.label,
                  classesTypography.left,
                )}
              >
                {left}
              </Typography>
            </Grid>
            <Grid item xs={6} classes={classesGrid}>
              <Typography
                align="right"
                className={clsx(
                  classesTypography.label,
                  classesTypography.right,
                )}
              >
                {right}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                aria-label={id}
                min={0}
                max={1}
                step={0.01}
                value={value}
                onChange={handleChangeValueSlider}
                classes={classesSlider}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

export default memo(FlavourPreferenceSlider);
